// import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from 'antd';
import DeleteMoneyBookUser from './DeleteMoneyBookUser';
import NativeNumber from '../../component/Numeral';
// import { defaultImage } from '../../methods/utils/general-utils';

interface IUserItem {
	item: any;
	index: any;
	removeUserPayment: (e: any) => void;
	activateUserPayment: (e: any) => void;
	setRefresh: (e: any) => void;
	setEditVisible: ({ status, id }: { status: boolean; id: any }) => void;
}

const Style = styled.div`
	padding: 20px;
	background-color: #f8f8f8;
	margin-bottom: 10px;
	display: grid;
	justify-content: space-between;
	grid-template-columns: 40px 1fr 1fr 120px 120px 120px 100px 120px;

	& .label {
		font-size: 13px;
		color: #808080;
		font-style: italic;
	}

	& .flex {
		display: flex;
	}

	& .balance {
		display: flex;

		& img {
			width: 24px;
			height: 24px;
			border-radius: 50%;
			margin-right: 10px;
		}
	}
`;

const User = ({
	item,
	index,
	removeUserPayment,
	activateUserPayment,
	setRefresh,
	setEditVisible,
}: IUserItem) => (
	<Style>
		<div>{index}</div>
		<div>{item?.email}</div>
		<div>
			{item?.user?.fullName} [{item?.user?.username}]
		</div>
		<div>
			<strong>
				<NativeNumber value={item?.amount} decimalPlaces={2} />
			</strong>
		</div>
		<div>
			<NativeNumber value={item?.nairaRate} decimalPlaces={2} />
		</div>
		<div>
			<strong>
				<NativeNumber value={item?.salaryInNaira} decimalPlaces={2} />
			</strong>
		</div>
		<div>{item?.status}</div>
		<div className="flex">
			{item?.status === 'active' ? (
				<Button
					size="small"
					style={{ fontSize: '12px', width: 'content-fit' }}
					danger
					onClick={() => {
						removeUserPayment(item?._id);
					}}
				>
					Don&apos;t pay
				</Button>
			) : (
				<Button
					size="small"
					style={{ fontSize: '12px', width: 'content-fit' }}
					danger
					onClick={() => {
						activateUserPayment(item?._id);
					}}
				>
					Activate
				</Button>
			)}
			<Button
				size="small"
				style={{ fontSize: '12px', width: 'content-fit', marginLeft: '8px' }}
				onClick={() => setEditVisible({ status: true, id: item?._id })}
			>
				Edit
			</Button>
			<DeleteMoneyBookUser
				id={item?.user?._id}
				listId={item?._id}
				setRefresh={setRefresh}
			/>
		</div>
	</Style>
);

export default User;
